<script setup>
const csrfConfig = window.Craft;


</script>

<template>
  <input type="hidden" :name="csrfConfig.csrfTokenName" :value="csrfConfig.csrfTokenValue" />
</template>
